/**
 * Main Flow Container. This will contain all the other container components.
 * This component is mounted at 'transfer/'.
 * If we ever move header/footer to React this is where it should live...
 */

import PropTypes from 'prop-types'

import React from 'react'
import { connect } from '../utils/p2p-connect'
import { withRouter } from 'react-router-dom'
import { triggerExternalHook } from '../actions/Actions'
import { SessionTimer } from '../lazy-components'
import { smallAndBigger } from '../../lib/styles/media-queries'

import * as ViewActions from '../actions/Actions'

import { paths } from '../homepage-routes'

const glamor = require('glamor')

export const setupHistoryListener = (history, dispatch) => {
  const PATHNAMES_FORCE_CANCEL_TRANSACTION = [
    paths.main,
    paths.send,
    paths.request
  ]
  
  return history.listen((location, action) => {
    if (
      action === 'POP' &&
      PATHNAMES_FORCE_CANCEL_TRANSACTION.includes(location.pathname)
    ) {
      dispatch(ViewActions.cancelledTransaction())
    }
  })
}

// Helper to clean up the history listener
export const cleanupHistoryListener = (unlisten) => {
  if (unlisten) {
    unlisten()
  }
}

export class Main extends React.Component {
  static propTypes = {
    children: PropTypes.object,
    dispatch: PropTypes.func,
    scrollToTop: PropTypes.bool,
    userAuthState: PropTypes.string,
    env: PropTypes.string,
    isBusinessUser: PropTypes.bool,
    history: PropTypes.object,
    location: PropTypes.object,
  }
  state = {
    navHeight: 120,
  }

  componentDidMount() {
    this.unlisten = setupHistoryListener(this.props.history, this.props.dispatch)
  }

  componentWillUnmount() {
    cleanupHistoryListener(this.unlisten)
  }

  componentDidUpdate() {
    if (this.props.scrollToTop) {
      requestAnimationFrame(() => window.scrollTo({ top: 0 }))
    }
  }

  render() {
    const userAuthState = this.props.userAuthState
    const { navHeight } = this.state

    const businessHeaderTop = glamor.css({
      [smallAndBigger]: {
        marginTop: navHeight - 34,
      },
    })
    return (
      <div
        className={`react-p2p_wrapper ${this.props.isBusinessUser &&
          businessHeaderTop}`}
      >
        {this.props.children}
        {userAuthState === 'LOGGEDIN' && (
          <SessionTimer
            onConfirmOpen={() =>
              this.props.dispatch(
                triggerExternalHook('sessionTimerOverlayRendered')
              )
            }
            extendURL="/myaccount/transfer/extendSession"
            env={this.props.env}
          />
        )}
      </div>
    )
  }
}

Main = connect(({ server = {} }) => ({
  userAuthState: server.userAuthState || '',
  env: server.env,
  isBusinessUser: server.businessAccountInfo.isBusinessUser,
}))(Main)

export default withRouter(Main)
